var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEbenen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ebenen__Icn/40px/Ebenen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,12.5 C23.6045695,12.5 24.5,13.3954305 24.5,14.5 L24.5,27.5 C24.5,28.6045695 23.6045695,29.5 22.5,29.5 L12.5,29.5 C11.3954305,29.5 10.5,28.6045695 10.5,27.5 L10.5,14.5 C10.5,13.3954305 11.3954305,12.5 12.5,12.5 Z M22.5,14.5 L12.5,14.5 L12.5,27.5 L22.5,27.5 L22.5,14.5 Z M26.5,8.5 C27.6045695,8.5 28.5,9.3954305 28.5,10.5 L28.5,23.5 C28.5,24.6045695 27.6045695,25.5 26.5,25.5 L26.5,10.5 L14.5,10.5 C14.5,9.3954305 15.3954305,8.5 16.5,8.5 L26.5,8.5 Z",
    id: ".._.._src_svg_Icn_40px_Ebenen__Combined-Shape-Copy-2",
    transform: "rotate(90 19.5 19)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbenen);
export default __webpack_public_path__ + "static/media/Ebenen.b3b34fc8d1c780a8da62f64c4e69697f.svg";
export { ForwardRef as ReactComponent };